import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ContactComponent implements OnInit {

	constructor(private _titleService: Title, private _meta: Meta) {
		this._titleService.setTitle( 'Contato - Hospital Veterinário Stolf');
	}

	ngOnInit() {
		this._meta.addTag({
			name: 'title',
			content: 'Contato - Hospital Veterinário Stolf - Lages SC'
		});
		this._meta.addTag({
			name: 'description',
			content: 'Estamos localizados na Rua Dr. Walmor Ribeiro, 288 – Bairro Coral – Lages, SC. Entre em contato conosco pelo telefone 3223-3278 e para emergências no 99991-4022'
		});
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact.component.ts